import { MILLISECONDS } from "@zenith/data/constants";

/**
 * Starts the timer used by localStorage.
 * @function
 * @name startTimer
 * @kind function
 * @param {number} initialSeconds Defines how many seconds is the timer.
 * @returns {void}
 * @exports
 */
export function startTimer(initialSeconds: number): void {
  const endTime = (
    new Date().getTime() +
    initialSeconds * MILLISECONDS
  ).toString();
  localStorage.setItem("endTime", endTime);
}
